/**
 * 从 OpenAI Responses API 返回值或后端纯文本摘要中，提取模型生成的文本内容。
 * 适用于 axios / fetch 调用。
 */
export function parseOpenAIResponse(
    responseData: OpenAIResponse | unknown
): string {
    // 入参本身为纯文本（少数调用方直接传入字符串）
    if (typeof responseData === 'string') {
        return responseData.trim();
    }

    if (!responseData || typeof responseData !== 'object') {
        return '';
    }

    const output = (responseData as OpenAIResponse).output;

    // output 为纯文本（如 risk/analysis 的 ai_analysis 字段）
    if (typeof output === 'string') {
        return output.trim();
    }

    if (!Array.isArray(output)) {
        return '';
    }

    let result = '';

    for (const item of output) {
        if (item.type !== 'message' || !Array.isArray(item.content)) {
            continue;
        }

        for (const content of item.content) {
            if (content.type === 'output_text' && typeof content.text === 'string') {
                result += content.text;
            }
        }
    }

    return result.trim();
}


export interface OpenAIResponse {
    /** OpenAI 结构化输出，或后端已提取的纯文本摘要 */
    output: OpenAIOutputItem[] | string;
}

export type OpenAIOutputItem = OpenAIMessageOutput;

export interface OpenAIMessageOutput {
    type: 'message';
    role?: 'assistant' | 'user' | 'system';
    content: OpenAIContent[];
}

export type OpenAIContent = OpenAIOutputText | OpenAIOutputJson;

export interface OpenAIOutputText {
    type: 'output_text';
    text: string;
}

export interface OpenAIOutputJson {
    type: 'output_json';
    json: unknown;
}
